import React from 'react'
import validation from './Send.validation'
import * as Joi from 'joi-browser'
import moment from 'moment'
import { Alert, Button, Form, Input } from 'reactstrap'
import DatePicker from 'react-datepicker'
import l10n from '../../localization'
import { connect } from 'react-redux'
import {
  meterErrorClear,
  newCombinedMeterReading,
} from '../../redux/actions/meter.actions'
import * as Styled from './Send.styles'

const CombinedReader = ({
  selectedMeter,
  meters = [],
  newCombinedMeterReading,
  meterErrorClear,
}) => {
  const initialMeterState = {
    readingDate1: null,
    value1: null,
    readingDate2: null,
    value2: null,
  }

  const [validate, setValidation] = React.useState({
    ...initialMeterState,
    readingDate: '',
  })

  const [readingDate1, setReadingDate1] = React.useState(moment())
  const [readingValue1, setReadingValue1] = React.useState(null)
  const [readingDate2, setReadingDate2] = React.useState(moment())
  const [readingValue2, setReadingValue2] = React.useState(null)
  const [readingValueAlertVisible, setReadingValueAlertVisible] =
    React.useState(false)

  let schema = Joi.object().keys({
    meterSiteCode: Joi.string().required(),
    meterCode1: Joi.string().required(),
    readingDate1: Joi.string().required(),
    value1: Joi.number().required(),
    meterCode2: Joi.string().required(),
    readingDate2: Joi.string().required(),
    value2: Joi.number().required(),
  })

  React.useEffect(() => {
    setReadingValueAlertVisible(false)
    setReadingDate1(moment())
    setReadingDate2(moment())
    setReadingValue1(0)
    setReadingValue2(0)
  }, [selectedMeter])

  const filterDates = (date) => {
    const { startDate, endDate } = getRestrictionDates()
    const currentDate = moment(date)
    return currentDate.isBetween(startDate, endDate, 'hour', '[]')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    meterErrorClear()

    const { userMeters } = selectedMeter

    // if (
    //   readingValue1 < userMeters[0].lastValue ||
    //   readingValue2 < userMeters[1].lastValue
    // ) {
    //   setReadingValueAlertVisible(true)
    //   return
    // }

    setReadingValueAlertVisible(false)

    const requestData = {
      meterSiteCode: selectedMeter.meterSiteCode,
      meterCode1: userMeters[0].meterCode,
      readingDate1: readingDate1 ? readingDate1.format() : null,
      value1: readingValue1,
      meterCode2: userMeters[1].meterCode,
      readingDate2: readingDate2 ? readingDate2.format() : null,
      value2: readingValue2,
    }

    const validateResponse = validation(requestData, schema)

    if (!validateResponse) {
      newCombinedMeterReading(requestData)
      setValidation({ ...initialMeterState })
      return
    }

    setValidation(validateResponse)
  }

  const getRestrictionDates = () => {
    const currentDate = moment()

    // Date restrictions from 21st to 28th by default
    let enabledFromDay = 21
    let enabledToDay = 28

    // In case of February, offset a bit
    if (currentDate.month() === 1) {
      enabledFromDay = 19
      enabledToDay = 26
    }

    if (process.env.REACT_APP_MEASUREMENT_ALWAYS_ENABLE === 'true') {
      enabledFromDay = moment().startOf('month').date()
      enabledToDay = moment().endOf('month').date()
    }

    return {
      startDate: moment(currentDate).set('date', enabledFromDay).startOf('day'),
      endDate: moment(currentDate).set('date', enabledToDay).endOf('day'),
    }
  }

  function renderSubmissionSection() {
    const { userMeters } = selectedMeter
    const lastReadingDate1 = moment(userMeters[0].lastReadingDate)
    const lastReadingDate2 = moment(userMeters[1].lastReadingDate)
    const { startDate, endDate } = getRestrictionDates()

    if (
      selectedMeter &&
      !selectedMeter.isOnlyActivated &&
      !selectedMeter.combined
    ) {
      return <Alert color="warning">{l10n.send.isOnlyActivated}</Alert>
    }

    if (
      (lastReadingDate1.month() === moment().month() &&
        lastReadingDate1.year() === moment().year()) ||
      (lastReadingDate2.month() === moment().month() &&
        lastReadingDate2.year() === moment().year())
    ) {
      return (
        <Alert color="warning" hidden={meters.newPositionSaved}>
          {l10n.send.alreadySubmittedManual}
          <br />
          {l10n.send.alreadySubmittedManual2}
        </Alert>
      )
    } else {
      if (moment().isBetween(startDate, endDate, 'hour', '[]')) {
        return (
          <>
            <Alert color="success" hidden={!meters.newPositionSaved}>
              {l10n.send.sendSuccess}
            </Alert>
            {!meters.newPositionSaved && (
              <Button color="primary" type="submit">
                {l10n.send.sendButton}
              </Button>
            )}
          </>
        )
      } else {
        return <Alert color="warning">{l10n.send.sendDateRestriction}</Alert>
      }
    }
  }

  function renderMeterReading1View(selectedUserMeter) {
    const currentDate = moment()
    const { startDate, endDate } = getRestrictionDates()

    if (
      selectedMeter &&
      selectedMeter.isOnlyActivated === false &&
      selectedMeter.combined === false
    ) {
      return null
    }

    const { errorMeters } = meters
    const meterErrors = errorMeters.find(
      (errMeter) => errMeter.meterCode === selectedUserMeter.meterCode
    )

    if (currentDate.isBetween(startDate, endDate, 'hour', '[]')) {
      return (
        <>
          <Styled.MeterReadingView>
            <Styled.MeterReadingRow>
              <Styled.MeterReadingKey>
                {l10n.send.dateOfPosition}
              </Styled.MeterReadingKey>
              <Styled.MeterReadingValue>
                <DatePicker
                  dateFormat="dd.MM.yyyy"
                  selected={readingDate1.toDate()}
                  disabled={
                    !selectedMeter.isOnlyActivated && !selectedMeter.combined
                  }
                  required
                  onChange={(newDate) => setReadingDate1(moment(newDate))}
                  filterDate={filterDates}
                  locale={l10n.general.locale}
                />
              </Styled.MeterReadingValue>
            </Styled.MeterReadingRow>
            <Styled.MeterReadingRow>
              <Styled.MeterReadingKey>
                {l10n.send.reading}
              </Styled.MeterReadingKey>
              <Styled.MeterReadingValue>
                <Input
                  type="number"
                  name="readingValue1"
                  id="readingValue1"
                  value={readingValue1 || ''}
                  placeholder="unesite novo stanje vodomjera"
                  disabled={
                    !selectedMeter.isOnlyActivated && !selectedMeter.combined
                  }
                  invalid={!!validate.value}
                  required
                  onChange={(e) => setReadingValue1(e.target.value)}
                />
              </Styled.MeterReadingValue>
            </Styled.MeterReadingRow>
            {meterErrors && (
              <Alert color="danger" style={{ marginTop: '20px' }}>
                {meterErrors.errorMessage}
              </Alert>
            )}
          </Styled.MeterReadingView>
        </>
      )
    }

    return null
  }

  function renderMeterReading2View(selectedUserMeter) {
    const currentDate = moment()
    const { startDate, endDate } = getRestrictionDates()

    if (
      selectedMeter &&
      selectedMeter.isOnlyActivated === false &&
      selectedMeter.combined === false
    ) {
      return null
    }

    const { errorMeters } = meters
    const meterErrors = errorMeters.find(
      (errMeter) => errMeter.meterCode === selectedUserMeter.meterCode
    )

    if (currentDate.isBetween(startDate, endDate, 'hour', '[]')) {
      return (
        <>
          <Styled.MeterReadingView>
            <Styled.MeterReadingRow>
              <Styled.MeterReadingKey>
                {l10n.send.dateOfPosition}
              </Styled.MeterReadingKey>
              <Styled.MeterReadingValue>
                <DatePicker
                  dateFormat="dd.MM.yyyy"
                  selected={readingDate2.toDate()}
                  disabled={
                    !selectedMeter.isOnlyActivated && !selectedMeter.combined
                  }
                  required
                  onChange={(newDate) => setReadingDate2(moment(newDate))}
                  filterDate={filterDates}
                  locale={l10n.general.locale}
                />
              </Styled.MeterReadingValue>
            </Styled.MeterReadingRow>
            <Styled.MeterReadingRow>
              <Styled.MeterReadingKey>
                {l10n.send.reading}
              </Styled.MeterReadingKey>
              <Styled.MeterReadingValue>
                <Input
                  type="number"
                  name="readingValue2"
                  id="readingValue2"
                  value={readingValue2 || ''}
                  placeholder="unesite novo stanje vodomjera"
                  disabled={
                    !selectedMeter.isOnlyActivated && !selectedMeter.combined
                  }
                  invalid={!!validate.value}
                  required
                  onChange={(e) => setReadingValue2(e.target.value)}
                />
              </Styled.MeterReadingValue>
            </Styled.MeterReadingRow>
            {meterErrors && (
              <Alert color="danger" style={{ marginTop: '20px' }}>
                {meterErrors.errorMessage}
              </Alert>
            )}
          </Styled.MeterReadingView>
        </>
      )
    }

    return null
  }

  const renderMeterHeaderData = (userMeter) => {
    return (
      <Styled.MeterDataView>
        <Styled.MeterDataRow>
          <Styled.MeterDataKey>
            {l10n.send.measurementMeter}
          </Styled.MeterDataKey>
          <Styled.MeterDataValue>
            {userMeter.meterCode ? userMeter.meterCode : '-'}
          </Styled.MeterDataValue>
        </Styled.MeterDataRow>
        <Styled.MeterDataRow>
          <Styled.MeterDataKey>
            {l10n.send.dateOfLastPosition}
          </Styled.MeterDataKey>
          <Styled.MeterDataValue>
            {userMeter.lastReadingDate
              ? moment(userMeter.lastReadingDate).format('DD.MM.YYYY')
              : '-'}
          </Styled.MeterDataValue>
        </Styled.MeterDataRow>
        <Styled.MeterDataRow>
          <Styled.MeterDataKey>{l10n.send.lastPosition}</Styled.MeterDataKey>
          <Styled.MeterDataValue>{userMeter.lastValue}</Styled.MeterDataValue>
        </Styled.MeterDataRow>
      </Styled.MeterDataView>
    )
  }

  if (!selectedMeter) return

  const selectedUserMeter1 = selectedMeter.userMeters[0]
  const selectedUserMeter2 = selectedMeter.userMeters[1]

  return (
    <Styled.RegularReaderWrapper>
      <Form onSubmit={handleSubmit}>
        <>
          <Styled.Card>
            {renderMeterHeaderData(selectedUserMeter1)}
            {renderMeterReading1View(selectedUserMeter1)}
          </Styled.Card>

          <Styled.Card>
            {renderMeterHeaderData(selectedUserMeter2)}
            {renderMeterReading2View(selectedUserMeter2)}
          </Styled.Card>

          <Styled.SubmitButtonView>
            {renderSubmissionSection()}
          </Styled.SubmitButtonView>
        </>
      </Form>

      <Alert
        color="danger"
        hidden={!meters.error}
        style={{ marginTop: '20px' }}
      >
        {l10n.serverErrors[meters.error] || meters.error}
      </Alert>

      <Alert
        color="danger"
        hidden={!readingValueAlertVisible}
        style={{ marginTop: '20px' }}
      >
        <Styled.LastPositionError>
          {l10n.send.lastPositionError}{' '}
          <Styled.Link to="/help">{l10n.send.lastPositionError2}</Styled.Link>{' '}
          {l10n.send.lastPositionError3}
        </Styled.LastPositionError>
      </Alert>
    </Styled.RegularReaderWrapper>
  )
}

export default connect(({ meters }) => ({ meters }), {
  newCombinedMeterReading,
  meterErrorClear,
})(CombinedReader)
